import { Dictionary } from '@ngrx/entity';
import { IDatiqLog } from '../models';
import { IDatiqLogEntity } from './datiq-log.models';

export const getLogs: (entities: Dictionary<IDatiqLogEntity>) => IDatiqLog[] = (
    entities: Dictionary<IDatiqLogEntity>
): IDatiqLog[] => {
    return !!entities
        ? Object.values(entities).map(
              (logEntity: IDatiqLogEntity): IDatiqLog => logEntity.log
          )
        : [];
};
